export const HrefJump = {
  data() {
    return {
      fieldHrefSlots: [],
      hrefComponent: {
        model: {
          title: '操作',
          width: '50%',
          visible: false,
          destroyOnClose: true,
          confirmLoading: false,
          style: {
            top: 0,
            left: 0,
            margin: 0,
            padding: 0
          },
          bodyStyle: {
            padding: '20px',
            maxHeight: 'calc(80vh - 108px)',
            overflowY: 'auto',
            overflowX: 'hidden'
          },
          // 隐藏掉取消按钮
          cancelButtonProps: { style: { display: 'none' } }
        },
        on: {
          ok: () => this.submit(),
          cancel: () => this.cancelModal()
        },
        is: null,
        params: {}
      },
      submitFn: null
    }
  },
  methods: {
    // 处理接收href参数
    handleAcceptHrefParams() {
      this.acceptHrefParams = {}
      let hrefparam = this.$route.query
      if (hrefparam) {
        this.acceptHrefParams = { ...hrefparam }
      }
    },
    //支持链接href跳转
    handleClickFieldHref(field, record, fieldExtendJson) {
      let fieldExtend = null
      if (fieldExtendJson) {
        fieldExtend = JSON.parse(fieldExtendJson)
      }
      let href = field.href
      let urlPattern = /(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?/
      let compPattern = /\.vue(\?.*)?$/
      if (typeof href === 'string') {
        href = href.trim().replace(/\${([^}]+)?}/g, (s1, s2) => record[ s2 ])
        // 打开外链
        if (urlPattern.test(href)) {
          // 如果是http链接则直接打开链接
          return window.open(href, '_blank')
        }
        // 打开自定义组件弹框
        if (compPattern.test(href)) {
          // 打开弹框展示自定义组件
          return this.openHrefCompModal(href, record, this.setHrefModalParams(fieldExtend))
        }
        // 打开默认的详情功能
        if(href === 'defaultDetail') return this.handleDetail(record)
        // 打开默认的编辑功能
        if(href === 'defaultEdit') return this.handleEdit(record)
        // 打开路由
        return this.$router.push(href)
      }
    },
    // 设置自定义组件弹框参数
    setHrefModalParams(config) {
      if(!config) return null
      return {
        [config.modalTitle && 'title']: config.modalTitle,
        [config.modalWidth && 'width']: config.modalWidth,
        ...config
      }
    },
    /**
     * 打开js增强模态框
     * @param href  组件路径或者http地址
     * @param detailData  详情对象
     * @param modalConfig  模态框配置信息
     * @author guochao
     * @date 2022/10/11 9:33
     */
    openHrefCompModal(href, detailData = null, modalConfig) {
      // 解析 href 参数
      let index = href.indexOf('?')
      let path = href
      if (index !== -1) {
        path = href.substring(0, index)
        let paramString = href.substring(index + 1, href.length)
        let paramArray = paramString.split('&')
        let params = {}
        paramArray.forEach(paramObject => {
          let paramItem = paramObject.split('=')
          params[ paramItem[ 0 ] ] = paramItem[ 1 ]
        })
        this.hrefComponent.params = params
      } else {
        this.hrefComponent.params = {}
      }
      // 给模态框组件设置参数
      detailData && (this.hrefComponent.params.detailData = detailData)
      // 设置模态框参数
      modalConfig && (this.hrefComponent.model = {
        ...this.hrefComponent.model,
        ...modalConfig
      })
      // 引入模态框内展示组件
      this.hrefComponent.is = () => import('@/views/' + (path.startsWith('/')? path.slice(1): path))
      this.hrefComponent.model.visible = true
    },
    // 关闭模态框
    cancelModal() {
      this.hrefComponent.model.visible = false
    },
    // 设置模态框提交方法
    setSubmitFn(submitFn) {
      this.submitFn = submitFn
    },
    // 模态框提交方法
    submit() {
      // 如果没有自定义提交方法则只关闭模态框
      if (!this.submitFn) return this.hrefComponent.model.visible = false
      let formData = this.$refs.dynamicComp.getFormData()
      let detailData = this.hrefComponent.params.detailData
      this.submitFn({ formData, detailData }, () => {
        this.hrefComponent.model.visible = false
        this.loadData(1)
      })
    },
    //处理显示长度
    handleColumnShowLength(column) {
      let { showLength, customRender } = column
      if (showLength && typeof customRender != 'function') {
        column.customRender = (text) => {
          if (text && text.length > showLength) {
            //return text.substr(0, showLength)+''
            return <span title={text}>{text.substr(0, showLength)}...</span>
          } else {
            return text
          }
        }
      }
    },
    /** 处理列中的 href 跳转和 dict 字典，使两者可以兼容存在 */
    handleColumnHrefAndDict(column = {}, fieldHrefSlotKeysMap = {}) {
      let { customRender, hrefSlotName, fieldExtendJson } = column
      if (!hrefSlotName && (column.scopedSlots && column.scopedSlots.customRender)) {
        //hrefSlotName = column.scopedSlots.customRender
      }
      // 如果 customRender 有值则代表使用了字典
      // 如果 hrefSlotName 有值则代表使用了href跳转
      // 两者可以兼容。兼容的具体思路为：先获取到字典替换的值，再添加href链接跳转
      if (customRender || hrefSlotName) {
        let dictCode = customRender
        let replaceFlag = '_replace_text_'
        column.customRender = (text, record) => {
          let value = text
          // 如果 dictCode 有值，就进行字典转换
          if (dictCode) {
            if (dictCode.startsWith(replaceFlag)) {
              let textFieldName = dictCode.replace(replaceFlag, '')
              value = record[ textFieldName ]
            } else {
              value = this.$filterMultiDictText(this.dictOptions[ dictCode ], text)
            }
          }
          //update-begin-author:taoyan date:20201204 for: 扩展参数设置列的内容长度
          if (column.showLength) {
            if (value && value.length > column.showLength) {
              value = value.substr(0, column.showLength) + '...'
            }
          }
          //update-end-author:taoyan date:20201204 for: 扩展参数设置列的内容长度

          // 如果 hrefSlotName 有值，就生成一个 a 标签，包裹住字典替换后（或原生）的值
          if (hrefSlotName) {
            let field = fieldHrefSlotKeysMap[ hrefSlotName ]
            if (field) {
              // 此处为 JSX 语法
              return (<a onClick={() => this.handleClickFieldHref(field, record, fieldExtendJson)}>{value}</a>)
            }
          }
          return value
        }
      }
    }

  }
}